import { PhoneListResponseDataItem, STRAPI_API } from '@trwl/strapi.api';
import { createEffect, createEvent, createStore } from 'effector';
import { persist } from 'effector-storage/local';

export const $phones = createStore<PhoneListResponseDataItem[]>([]);

export const fetchPhonesFx = createEffect<
  void,
  PhoneListResponseDataItem[],
  Error
>(async () => {
  return STRAPI_API.PhoneApi.getPhones().then(({ data }) => {
    return data.data ?? [];
  });
});

$phones.on(fetchPhonesFx.doneData, (_, brands) => brands);

export const loadPhones = createEvent();
loadPhones.watch(fetchPhonesFx);
persist({ store: $phones, key: 'phones' });
